"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _lodash2 = _interopRequireDefault(require("lodash.memoize"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _clientAwsS = require("@devsta/client-aws-s3");

var _TeamSummary = _interopRequireDefault(require("./TeamSummary"));

var _UsersList = _interopRequireDefault(require("./UsersList"));

var _CreateTeamModal = _interopRequireDefault(require("./CreateTeamModal"));

var _InviteUsersNotice = _interopRequireDefault(require("./InviteUsersNotice"));

var _AssignUserModal = _interopRequireDefault(require("../../../../../common/components/AssignUserModal"));

var _InviteUsersModal = _interopRequireDefault(require("../../../../../common/components/InviteUsersModal"));

require("../styles/_manage-teams.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MODAL = {
  INVITE_NOTICE: 'invite-notice',
  CREATE_TEAM: 'create-team',
  INVITE_USERS: 'invite-users',
  MANAGE_USERS: 'manage-users'
};
var DISPLAY_LIMIT = 12;

var ManageTeams = /*#__PURE__*/function (_Component) {
  _inherits(ManageTeams, _Component);

  function ManageTeams() {
    var _this;

    _classCallCheck(this, ManageTeams);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ManageTeams).call(this));

    _defineProperty(_assertThisInitialized(_this), "recentlyAddedTeam", undefined);

    _defineProperty(_assertThisInitialized(_this), "openManageUsersModal", (0, _lodash2.default)(function (teamId) {
      return function () {
        _this.setState({
          manageUsersModalTeamId: teamId,
          openedModalName: MODAL.MANAGE_USERS
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "openModal", (0, _lodash2.default)(function (modalName) {
      return function () {
        _this.setState({
          openedModalName: modalName
        }, function () {
          if (document.body) {
            document.body.classList.add('no-scroll');
          }
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "closeModal", (0, _lodash2.default)(function (modalName) {
      return function () {
        var openedModalName = _this.state.openedModalName;

        if (modalName !== openedModalName) {
          return;
        }

        _this.setState({
          openedModalName: ''
        }, function () {
          if (document.body) {
            document.body.classList.remove('no-scroll');
          }
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onManageTeamClick", (0, _lodash2.default)(function (teamId) {
      var _this$props = _this.props,
          history = _this$props.history,
          orgPermissions = _this$props.orgPermissions;

      if (!(0, _commonReact.hasPermission)('MANAGE_TEAM', orgPermissions)) {
        return false;
      }

      history.push("/team/".concat(teamId));
      return true;
    }));

    _defineProperty(_assertThisInitialized(_this), "addTeamToList", function (newTeamPreview) {
      var teams = _this.state.teams;

      _this.setState({
        teams: [].concat(_toConsumableArray(teams), [newTeamPreview])
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTeamCreated", function (newTeamPreview) {
      var onCreditsUpdated = _this.props.onCreditsUpdated;

      _this.addTeamToList(newTeamPreview);

      _this.recentlyAddedTeam = newTeamPreview;

      _this.setState({
        manageUsersModalTeamId: newTeamPreview.teamId
      }, _this.openModal(MODAL.INVITE_NOTICE));

      onCreditsUpdated();
    });

    _defineProperty(_assertThisInitialized(_this), "getRemainingUsersNumber", function () {
      var _this$props$orgUserAl = _this.props.orgUserAllowance,
          orgUserAllowance = _this$props$orgUserAl === void 0 ? 0 : _this$props$orgUserAl;

      if (orgUserAllowance === -1) {
        return orgUserAllowance;
      }

      var teams = _this.state.teams;
      var allocatedOrgUserAllowance = teams.reduce(function (allocatedSeats, teamPreview) {
        var teamUserAllowance = teamPreview && teamPreview.userAllowance;
        return allocatedSeats + teamUserAllowance;
      }, 0);
      var remainingOrgUserAllowance = orgUserAllowance - allocatedOrgUserAllowance;
      return remainingOrgUserAllowance >= 0 ? remainingOrgUserAllowance : 0;
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteSuccess", function (teamId) {
      var onCreditsUpdated = _this.props.onCreditsUpdated;
      var teams = _this.state.teams;
      onCreditsUpdated();
      return void _this.setState({
        teams: teams.filter(function (teamDetails) {
          return teamDetails.teamId !== teamId;
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchRoles", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props2, getRoles, organisationId, _ref2, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, getRoles = _this$props2.getRoles, organisationId = _this$props2.organisationId;
              _context.next = 3;
              return getRoles(organisationId);

            case 3:
              _ref2 = _context.sent;
              data = _ref2.data;
              error = _ref2.error;

              if (!(error || !data)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: true
              }));

            case 8:
              _this.setState({
                organisationRoles: data.ORGANISATION,
                teamRoles: data.TEAM
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "retrieveBucketKeyUrls", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
        var _this$props3, apolloClient, organisationId, teamsWithImages, teams;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props3 = _this.props, apolloClient = _this$props3.apolloClient, organisationId = _this$props3.organisationId;
                _context3.prev = 1;
                _context3.next = 4;
                return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                  apiClient: apolloClient,
                  dataArray: data.getTeams,
                  substitutedKeys: ['imageUrl']
                });

              case 4:
                teamsWithImages = _context3.sent;
                _context3.next = 7;
                return Promise.all(teamsWithImages.map( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(team, index) {
                    var membersWithUserImages;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(index > DISPLAY_LIMIT)) {
                              _context2.next = 2;
                              break;
                            }

                            return _context2.abrupt("return", team);

                          case 2:
                            _context2.next = 4;
                            return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                              apiClient: apolloClient,
                              dataArray: team.membersPreview.map(function (preview) {
                                return _objectSpread({}, preview, {
                                  organisationId: organisationId
                                });
                              }),
                              substitutedKeys: ['imageUrl']
                            });

                          case 4:
                            membersWithUserImages = _context2.sent;
                            return _context2.abrupt("return", _objectSpread({}, team, {
                              membersPreview: membersWithUserImages
                            }));

                          case 6:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2, _x3) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 7:
                teams = _context3.sent;

                _this.setState({
                  teams: teams,
                  loading: false
                });

                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](1);

                _this.setState({
                  teams: data.getTeams,
                  loading: false
                });

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 11]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var getUsersAndTeams, _ref6, data, error;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              getUsersAndTeams = _this.props.getUsersAndTeams;
              _context4.prev = 1;

              _this.setState({
                loading: true
              });

              _context4.next = 5;
              return getUsersAndTeams();

            case 5:
              _ref6 = _context4.sent;
              data = _ref6.data;
              error = _ref6.error;

              if (!(!data || error)) {
                _context4.next = 10;
                break;
              }

              return _context4.abrupt("return", void _this.setState({
                error: true,
                loading: false
              }));

            case 10:
              _this.retrieveBucketKeyUrls(data);

              _context4.next = 16;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](1);

              _this.setState({
                error: true,
                loading: false
              });

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 13]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "renderTeamListItem", function (teamPreview) {
      var _this$props4 = _this.props,
          orgPermissions = _this$props4.orgPermissions,
          deleteTeam = _this$props4.deleteTeam;
      return _react.default.createElement(_TeamSummary.default, {
        key: teamPreview.teamId,
        teamPreview: teamPreview,
        onClick: function onClick() {
          return _this.onManageTeamClick(teamPreview.teamId);
        },
        orgPermissions: orgPermissions,
        deleteTeam: deleteTeam,
        onDeleteSuccess: _this.onDeleteSuccess
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTeamsList", function () {
      var teams = _this.state.teams;
      return !(0, _lodash.default)(teams) ? _react.default.createElement(_uiKit.List, {
        data: teams,
        renderCardItem: _this.renderTeamListItem,
        maxDisplayNum: 40
      }) : _react.default.createElement("div", {
        className: "manage-teams__empty"
      }, _react.default.createElement("p", null, "Your Organisation has not created any teams yet"));
    });

    _defineProperty(_assertThisInitialized(_this), "onInviteUserToTeam", function () {
      _this.setState({
        inviteUserModalVisible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInviteUsersModalClose", function () {
      _this.setState({
        inviteUserModalVisible: false,
        openedModalName: MODAL.MANAGE_USERS
      });
    });

    _this.state = {
      openedModalName: '',
      manageUsersModalTeamId: '',
      loading: false,
      organisationRoles: [],
      teamRoles: [],
      teams: [],
      error: false,
      inviteUserModalVisible: false
    };
    return _this;
  }

  _createClass(ManageTeams, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchData();
      this.fetchRoles();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          createTeam = _this$props5.createTeam,
          history = _this$props5.history,
          orgPermissions = _this$props5.orgPermissions,
          searchOrgMemberships = _this$props5.searchOrgMemberships;
      var _this$state = this.state,
          teams = _this$state.teams,
          loading = _this$state.loading,
          manageUsersModalTeamId = _this$state.manageUsersModalTeamId,
          openedModalName = _this$state.openedModalName,
          organisationRoles = _this$state.organisationRoles,
          teamRoles = _this$state.teamRoles,
          error = _this$state.error,
          inviteUserModalVisible = _this$state.inviteUserModalVisible;

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      var hasManagePermission = (0, _commonReact.hasPermission)('MANAGE_ORGANISATION', orgPermissions);
      var isAssignUserModalVisible = openedModalName === MODAL.MANAGE_USERS;

      var _ref7 = this.recentlyAddedTeam || {},
          teamId = _ref7.teamId,
          name = _ref7.name;

      var selectedTeam = {
        value: teamId,
        label: name
      };
      return _react.default.createElement("div", {
        className: "manage-teams"
      }, hasManagePermission ? [_react.default.createElement(_CreateTeamModal.default, {
        searchOrgMemberships: searchOrgMemberships,
        visible: openedModalName === MODAL.CREATE_TEAM,
        onClose: this.closeModal(MODAL.CREATE_TEAM),
        createTeam: createTeam,
        onTeamCreated: this.handleTeamCreated,
        remainingUsersNumber: this.getRemainingUsersNumber(),
        key: "item1"
      }), _react.default.createElement(_InviteUsersNotice.default, {
        visible: openedModalName === MODAL.INVITE_NOTICE,
        onClose: this.closeModal(MODAL.INVITE_NOTICE),
        onSave: this.openManageUsersModal(manageUsersModalTeamId),
        key: "item2"
      })] : null, isAssignUserModalVisible && _react.default.createElement(_AssignUserModal.default, {
        visible: isAssignUserModalVisible,
        onClose: this.closeModal(MODAL.MANAGE_USERS),
        teamId: manageUsersModalTeamId,
        onSave: this.fetchData,
        teamRoles: teamRoles,
        hasManagePermission: hasManagePermission,
        onInviteUserToTeam: this.onInviteUserToTeam
      }), inviteUserModalVisible && _react.default.createElement(_InviteUsersModal.default, {
        visible: inviteUserModalVisible,
        onClose: this.onInviteUsersModalClose,
        onInvited: this.fetchData,
        organisationRoles: organisationRoles,
        selectedTeam: selectedTeam
      }), _react.default.createElement("div", {
        className: "manage-teams__label"
      }, _react.default.createElement(_uiKit.Icon, {
        name: "user",
        color: "russian",
        size: 25
      }), _react.default.createElement("span", null, "Manage Teams"), hasManagePermission ? _react.default.createElement(_uiKit.Button, {
        type: "SECONDARY",
        small: true,
        onClick: this.openModal(MODAL.CREATE_TEAM)
      }, "CREATE NEW TEAM") : null), loading ? _react.default.createElement("div", null, "Loading...") : this.renderTeamsList(), _react.default.createElement("hr", null), _react.default.createElement("div", {
        className: "manage-teams__label"
      }, _react.default.createElement(_uiKit.Icon, {
        name: "user",
        color: "russian",
        size: 25
      }), _react.default.createElement("span", null, "Manage Users")), _react.default.createElement(_UsersList.default, {
        history: history,
        openManageUsersModal: this.openModal(MODAL.INVITE_USERS),
        organisationRoles: organisationRoles,
        teams: teams,
        displayLimit: DISPLAY_LIMIT,
        orgPermissions: orgPermissions
      }));
    }
  }]);

  return ManageTeams;
}(_react.Component);

exports.default = ManageTeams;